












































































import { Component, Vue } from 'vue-property-decorator';
import { Mutation, State, Action } from 'vuex-class';
import _groupBy from 'lodash.groupby';
import StoreLayout from '~/components/Store/StoreLayout.vue';
import GameInfo from '~/components/Games/GameInfo.vue';
import GameNewsArticles from '~/components/Games/GameNewsArticles.vue';
import BuyNodePromotion from '~/components/Promotions/BuyNodePromotion.vue';
import { IGame } from '~/store/games/types';
import { ICurrentPage } from '~/store/types';
import { IUser } from '~/store/profile/types';
import { namedGameIntlHead } from '~/utils/i18n_head';
import { UserItem } from '~/types/user-items';

@Component({
  head: namedGameIntlHead(),
  components: {
    StoreLayout,
    GameInfo,
    GameNewsArticles,
    BuyNodePromotion,
  },
  middleware: 'dontShowGame',
})
export default class Game extends Vue {
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];
  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @State('discordLink') readonly discordLink!: string;
  @State(inventory => inventory.userItems, { namespace: 'inventory' })
  userItems!: UserItem[];

  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  @Action('getUserItems', { namespace: 'inventory' })
  private getUserItems!: (collection: string) => void;

  scrollToTop = false;

  get gameInfo(): IGame {
    const gameRoute = this.$nuxt.$route.params.name;
    const currentGame = this.games.filter(
      (game: any) => game.route === gameRoute,
    );
    return currentGame[0];
  }

  get defaultStoreFilters() {
    return {
      games: {
        field: 'game',
        comparator: 'in',
        type: 'string',
        values: [
          {
            name: this.gameInfo.name,
            value: this.gameInfo.name,
            comparator: 'eq',
            selected: true,
          },
          {
            name: this.gameInfo.collection,
            value: this.gameInfo.collection,
            comparator: 'eq',
            selected: true,
          },
        ],
      },
    };
  }

  get ownedItems() {
    const items = this.userItems.filter(
      item => item.collection === this.gameInfo.collection,
    );

    return items;
  }

  get userItemsCount() {
    return this.ownedItems.reduce((acc, item) => acc + item.quantity, 0);
  }

  async created() {
    this.updateCurrentPage({
      title: this.gameInfo.name,
      backIcon: 'arrow_back_ios',
      backRoute: '/games',
    });

    this.getUserItems(this.gameInfo.collection);
  }
}
